module.exports = __webpack_public_path__ + "static/img/bigcur.970a220.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/bigcur.png
// module id = cQAU
// module chunks = 1